import { NavLink } from 'react-router-dom';
import MedicalDeviceIcon from '../../../assets/icons/medical-device.svg?react';
import ExternalLinkIcon from '../../../assets/icons/external-link-icon.svg?react';
import Tooltip from '../Tooltip';
import styles from './MedicalDeviceIndicator.module.scss';
import useBmsVersion from '../../BMSLabelling/useBmsVersion';

type Props = {
  width?: number;
  height?: number;
  fullPage?: boolean;
};

export default function MedicalDeviceIndicator({ width = 22, height = 18, fullPage }: Props) {
  const { data } = useBmsVersion();

  if (!data?.version) {
    return null;
  }

  const Icon = (
    <Tooltip content={<TooltipContent />} allowHover delay={250}>
      <MedicalDeviceIcon width={width} height={height} />
    </Tooltip>
  );

  if (!fullPage) {
    return Icon;
  }

  return (
    <div className="flex gap-5 vertical-align font-inter">
      {Icon}
      <span className="fw-600 fs-14 grey-400">Bedömningar i denna vy är framtagna med medicinteknik.</span>
    </div>
  );
}

const TooltipContent = () => {
  return (
    <div className={styles.tooltipContent}>
      <p>BTD CDSS</p>
      <p>
        Bedömningen/informationen vid denna ikon är automatiskt genererad av systemet med hjälp av medicintekniska
        funktioner.
      </p>
      <p>
        <NavLink to={`/bms`} target="_blank">
          Läs mer här <ExternalLinkIcon width={10} height={10} />
        </NavLink>
      </p>
    </div>
  );
};
